import comp0 from '@/app/scriptconsent'
import comp1 from '@/app/sentry'
import comp2 from '@/app/cookieconsent'
import comp3 from '@/app/dialog'
import comp4 from '@/app/beerslider'
import comp5 from '@/app/featureScroller'
import comp6 from '@/app/floatingScreens'
import comp7 from '@/app/galleryoverlay'
import comp8 from '@/app/characterBlender'
import comp9 from '@/app/carousel'
import comp10 from '@/app/marquee'
import comp11 from '@/app/statscounter'
import comp12 from '@/app/videoPlayer'
import comp13 from '@/app/roicalculator'
import comp14 from '@/app/customCarousel'
import comp15 from '@/app/stillController'
import comp16 from '@/app/svgZoomer'
import comp17 from '@/app/formCaptcha'
import comp18 from '@/app/navToggle'
import comp19 from '@/app/scrollTop'
import comp20 from '@/app/characterBlender'
import comp21 from '@/app/videoPlayer'
import comp22 from '@/app/filterShowcases'
import comp23 from '@/app/active'
import comp24 from '@/app/collapsible'
import comp25 from '@/app/scrollTop'
import comp26 from '@/app/historticRedirect'
import comp27 from '@/app/scriptconsent'
import comp28 from '@/app/sentry'
import comp29 from '@/app/cookieconsent'
import comp30 from '@/app/dialog'
import comp31 from '@/app/beerslider'
import comp32 from '@/app/featureScroller'
import comp33 from '@/app/floatingScreens'
import comp34 from '@/app/galleryoverlay'
import comp35 from '@/app/carousel'
import comp36 from '@/app/marquee'
import comp37 from '@/app/statscounter'
import comp38 from '@/app/roicalculator'
import comp39 from '@/app/customCarousel'
import comp40 from '@/app/stillController'
import comp41 from '@/app/svgZoomer'
import comp42 from '@/app/formCaptcha'
import comp43 from '@/app/navToggle'
import comp44 from '@/app/scriptconsent'
import comp45 from '@/app/sentry'
import comp46 from '@/app/cookieconsent'
import comp47 from '@/app/dialog'
import comp48 from '@/app/beerslider'
import comp49 from '@/app/featureScroller'
import comp50 from '@/app/floatingScreens'
import comp51 from '@/app/galleryoverlay'
import comp52 from '@/app/characterBlender'
import comp53 from '@/app/carousel'
import comp54 from '@/app/marquee'
import comp55 from '@/app/statscounter'
import comp56 from '@/app/videoPlayer'
import comp57 from '@/app/roicalculator'
import comp58 from '@/app/customCarousel'
import comp59 from '@/app/stillController'
import comp60 from '@/app/svgZoomer'
import comp61 from '@/app/formCaptcha'
import comp62 from '@/app/navToggle'
import comp63 from '@/app/scrollTop'
import comp64 from '@/app/carousel'
import comp65 from '@/app/scrollTop'
import comp66 from '@/app/scriptconsent'
import comp67 from '@/app/sentry'
import comp68 from '@/app/cookieconsent'
import comp69 from '@/app/dialog'
import comp70 from '@/app/beerslider'
import comp71 from '@/app/featureScroller'
import comp72 from '@/app/floatingScreens'
import comp73 from '@/app/galleryoverlay'
import comp74 from '@/app/characterBlender'
import comp75 from '@/app/marquee'
import comp76 from '@/app/statscounter'
import comp77 from '@/app/videoPlayer'
import comp78 from '@/app/roicalculator'
import comp79 from '@/app/customCarousel'
import comp80 from '@/app/stillController'
import comp81 from '@/app/svgZoomer'
import comp82 from '@/app/formCaptcha'
import comp83 from '@/app/navToggle'
var map={}; 
map['app/scriptconsent']=comp0;
map['app/sentry']=comp1;
map['app/cookieconsent']=comp2;
map['app/dialog']=comp3;
map['app/beerslider']=comp4;
map['app/featureScroller']=comp5;
map['app/floatingScreens']=comp6;
map['app/galleryoverlay']=comp7;
map['app/characterBlender']=comp8;
map['app/carousel']=comp9;
map['app/marquee']=comp10;
map['app/statscounter']=comp11;
map['app/videoPlayer']=comp12;
map['app/roicalculator']=comp13;
map['app/customCarousel']=comp14;
map['app/stillController']=comp15;
map['app/svgZoomer']=comp16;
map['app/formCaptcha']=comp17;
map['app/navToggle']=comp18;
map['app/scrollTop']=comp19;
map['app/characterBlender']=comp20;
map['app/videoPlayer']=comp21;
map['app/filterShowcases']=comp22;
map['app/active']=comp23;
map['app/collapsible']=comp24;
map['app/scrollTop']=comp25;
map['app/historticRedirect']=comp26;
map['app/scriptconsent']=comp27;
map['app/sentry']=comp28;
map['app/cookieconsent']=comp29;
map['app/dialog']=comp30;
map['app/beerslider']=comp31;
map['app/featureScroller']=comp32;
map['app/floatingScreens']=comp33;
map['app/galleryoverlay']=comp34;
map['app/carousel']=comp35;
map['app/marquee']=comp36;
map['app/statscounter']=comp37;
map['app/roicalculator']=comp38;
map['app/customCarousel']=comp39;
map['app/stillController']=comp40;
map['app/svgZoomer']=comp41;
map['app/formCaptcha']=comp42;
map['app/navToggle']=comp43;
map['app/scriptconsent']=comp44;
map['app/sentry']=comp45;
map['app/cookieconsent']=comp46;
map['app/dialog']=comp47;
map['app/beerslider']=comp48;
map['app/featureScroller']=comp49;
map['app/floatingScreens']=comp50;
map['app/galleryoverlay']=comp51;
map['app/characterBlender']=comp52;
map['app/carousel']=comp53;
map['app/marquee']=comp54;
map['app/statscounter']=comp55;
map['app/videoPlayer']=comp56;
map['app/roicalculator']=comp57;
map['app/customCarousel']=comp58;
map['app/stillController']=comp59;
map['app/svgZoomer']=comp60;
map['app/formCaptcha']=comp61;
map['app/navToggle']=comp62;
map['app/scrollTop']=comp63;
map['app/carousel']=comp64;
map['app/scrollTop']=comp65;
map['app/scriptconsent']=comp66;
map['app/sentry']=comp67;
map['app/cookieconsent']=comp68;
map['app/dialog']=comp69;
map['app/beerslider']=comp70;
map['app/featureScroller']=comp71;
map['app/floatingScreens']=comp72;
map['app/galleryoverlay']=comp73;
map['app/characterBlender']=comp74;
map['app/marquee']=comp75;
map['app/statscounter']=comp76;
map['app/videoPlayer']=comp77;
map['app/roicalculator']=comp78;
map['app/customCarousel']=comp79;
map['app/stillController']=comp80;
map['app/svgZoomer']=comp81;
map['app/formCaptcha']=comp82;
map['app/navToggle']=comp83;
export default map;